import { Component, OnInit, Input } from '@angular/core';
import { FormatoAsistencialEntity, FiltrosFormatoAsistencialEntity, NodoEntity } from 'src/app/services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.css']
})
export class EditorComponent implements OnInit {

  @Input() data: FormatoAsistencialEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;
  @Input() nodo: NodoEntity;

  titulo: string;

  constructor() { }

  ngOnInit() {
    if(this.nodo && this.filtros) {
      this.onProcess();
    }
  }

  onProcess(){
    this.titulo = this.nodo.titulo;
  }

}
